import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles =
  ({ theme }) => css`
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
    list-style: none;

    &::after {
      content: "";

      position: absolute;
      top: -${theme.spacings.peta};
      left: ${theme.spacings.exa};
      width: 1px;
      height: 100%;
      background: ${theme.colors.n100};
    }

    &:first-of-type {
      margin-top: ${theme.spacings.peta};

      &::before {
        content: "";
        position: absolute;
        top: -${theme.spacings.mega};
        left: 41px;
        display: block;
        width: 16px;
        height: 16px;
        border: 5px solid ${theme.colors.white};
        border-radius: ${theme.borderRadius.circle};
        background: ${theme.colors.n100}
        box-shadow: 0px 0px 0px 1px ${theme.colors.n100};
      }

      &::after {
        top: 0;
        height: calc(100% - 70px);
      }
    }
  `

export const ListElement = styled('ul')(baseStyles)

const textTitleStyles =
  ({ theme }) => css`
    display: block;
    margin-bottom : ${theme.spacings.bit};

    color: ${theme.colors.n900};
    font-size: 14px;
  `
export const TextTitle = styled('span')(textTitleStyles)

const itemStyles =
  ({ theme }) => css`
    margin: 0;

    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: ${theme.spacings.mega} ${theme.spacings.giga};
    &:nth-of-type(2n) {
      background: ${theme.colors.background};

      [data-circle="circle"] {
        background: ${theme.colors.background};
      }
    }

    ${theme.media.mega} {
      padding: ${theme.spacings.giga};
      border-radius: 100px;
    }
  `

export const ItemPoints = styled('li')(itemStyles)

const contentStyles =
  ({ theme }) => css`
    display: flex;
    align-items: center;

    flex: 1;

    ${theme.media.mega} {
      margin-right: 64px;
    }

    ${theme.media.kilo} {
      margin-right: ${theme.spacings.giga}
    }
  `

export const ContentElement = styled('div')(contentStyles)

const circleStyles =
  ({ theme }) => css`
    position: relative;
    z-index: 1;
    width: 50px;
    height: 50px;
    margin-right: ${theme.spacings.mega};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacings.kilo};
    border: 1px solid ${theme.colors.n100};
    border-radius: 50%;
    background: ${theme.colors.white};

    svg {
      width: 100%;
      height: 100%;
    }

    ${theme.media.mega} {
      margin-right: ${theme.spacings.giga};
    }
  `

export const CircleElement = styled('div')(circleStyles)

const infosStyles = () => css`
  flex: 1;
`

export const Infos = styled('div')(infosStyles)

const textDateStyles = ({ theme }) => css`
    display: block;
    margin-bottom : ${theme.spacings.byte};

    color: ${theme.colors.n500};
    font-size: 12px;

    ${theme.media.mega} {
      margin-bottom: ${theme.spacings.mega};
    }
  `

export const TextDate = styled('span')(textDateStyles)

const textPointsStyles =
  ({ theme }) => css`
    display: block;
    font-size: 14px;
    font-weight: ${theme.font.weight.semibold};
    background: linear-gradient(${theme.colors.f500}, ${theme.colors.v300});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;


    ${theme.media.mega} {
      margin-right: ${theme.spacings.exa};
      font-size: 18px;
    }
  `
export const TextPoints = styled('span')(textPointsStyles)
